
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        active: Boolean as PropType<boolean>,
        default: () => false
    }
})
